import * as Sentry from "@sentry/react";
import {browserOfflineOptions, browserOfflineTransport} from "./diagnostics/offlineTransport";
import {sanitizeBrowserBreadcrumb, sanitizeBrowserEvent} from "./diagnostics/sanitizeEvent";
import {envService} from "./services/env.service";
import {CHUNK_RELOAD_KEY, isChunkLoadMessage} from "./utils/chunkLoad.util";

declare const __MYTOUR_RELEASE__: string | undefined;

export function diagnosticDedupeIntegration(): ReturnType<typeof Sentry.dedupeIntegration> {
  const dedupe = Sentry.dedupeIntegration();
  return {
    ...dedupe,
    processEvent(event, hint, client) {
      return event.tags?.["diagnostic.managed"] === "true" || !dedupe.processEvent
        ? event
        : dedupe.processEvent(event, hint, client);
    },
  };
}

export function initSentry() {
  let environment = "dev";
  if (
    window.location.host === "latest.mytour-services.tech" ||
    window.location.host === "latest.mytour.tech"
  ) {
    environment = "latest";
  } else if (
    window.location.host === "canary.mytour-services.tech" ||
    window.location.host === "canary.mytour.tech"
  ) {
    environment = "canary";
  } else if (
    window.location.host === "mytour-services.tech" ||
    window.location.host === "mytour.tech" ||
    window.location.host === "app.mytour.tech"
  ) {
    environment = "production";
  }
  const mode = envService.getMode();
  if (mode === "prod" || mode === "canary") {
    Sentry.init({
      dsn: "https://89c1ebce7fc943b8a497fe7a33ee6a9c@o1191243.ingest.sentry.io/6313996",
      sendDefaultPii: false,
      release: typeof __MYTOUR_RELEASE__ === "string" ? __MYTOUR_RELEASE__ : undefined,
      transport: (options) => browserOfflineTransport({...options, ...browserOfflineOptions}),
      beforeBreadcrumb: sanitizeBrowserBreadcrumb,
      environment,
      integrations: [
        Sentry.browserApiErrorsIntegration(),
        Sentry.globalHandlersIntegration({
          onerror: true,
          onunhandledrejection: true,
        }),
        diagnosticDedupeIntegration(),
      ],
      beforeSend(event) {
        const message = event.exception?.values?.[0]?.value ?? event.message ?? "";
        if (isChunkLoadMessage(message)) {
          try {
            if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === "1") {
              return null;
            }
          } catch {}
        }
        return sanitizeBrowserEvent(event);
      },
    });
  }
}
